(function (global, factory) {
  if ('function' == typeof define && define.amd) define(['exports', 'minimist'], factory);else if ('undefined' != typeof exports) factory(exports, require('minimist'));else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.minimist), global.parse = mod.exports;
  }
})(this, function (exports, _minimist) {
  'use strict';

  Object.defineProperty(exports, '__esModule', {
    value: !0
  }), exports.default = function (argv, options) {
    Object.assign(this.config, options), this.config.help && (this.option('help', 'Output usage information'), this.command('help', 'Display help', this.showHelp)), this.raw = (0, _minimist2.default)(argv.slice(1), this.config.minimist), this.config.version && this.checkVersion(this.parent);
    var subCommand = this.raw._[1],
        helpTriggered = this.raw.h || this.raw.help,
        args = {},
        defined = this.isDefined(subCommand, 'commands'),
        optionList = this.getOptions(defined);
    return (Object.assign(args, this.raw), args._.shift(), this.sub = args._, defined) ? (this.runCommand(defined, optionList), {}) : (this.config.help && helpTriggered && this.showHelp(), optionList);
  };

  var _minimist2 = function (obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }(_minimist);
});